<template>
    <div>
        <tabs-header-mobile
            route-to-name="SupplierProductsEdit"
            title="Видимость"
        />

        <form class="product-form supplier-tab" @submit.prevent="null">
            <product-visibility
                :visibility="product.visibility"
                @onChange="onProductVisibilityChange($event)"
            />

            <div class="product-form__btn-wrap">
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :class="{ loading }"
                    :disabled="!product.id"
                    @click="saveProduct()"
                >
                    Сохранить изменения
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import TabsHeaderMobile from '@/components/Cabinet/Tabs/TabsHeaderMobile'
import ProductVisibility from '@/components/Cabinet/Supplier/Product/ProductVisibility'
import { mapState, mapGetters, mapActions } from 'vuex'

import { required, maxLength, between, integer } from 'vuelidate/lib/validators'

const validations = {
    product: {
        visibility: { required }
    }
}

export default {
    name: 'EditVisibility',
    components: { TabsHeaderMobile, ProductVisibility },
    data() {
        return {
            product: {
                id: '', //indicate product was loaded
                visibility: 0
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters('supplierProducts', ['getFormattedProduct']),

        ...mapState('insert', [
            'insertMaterials',
            'insertColors',
            'insertFacets'
        ])
    },
    validations,
    watch: {
        getFormattedProduct: {
            handler: function(val) {
                if (!this.product.id && Object.keys(val).length) {
                    this.setProductFields()
                }
            },
            deep: true
        }
    },
    mounted() {
        if (Object.keys(this.getFormattedProduct).length) {
            this.setProductFields()
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['updateProduct', 'getProduct']),
        setProductFields() {
            this.product = {
                ...this.getFormattedProduct
            }
        },
        onProductVisibilityChange(val) {
            this.product.visibility = val
        },
        async saveProduct() {
            if (this.loading) return

            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.loading = true

                let data = {
                    AccessLevel: this.product.visibility || undefined //if 0 not send
                }

                try {
                    let payload = {
                        id: this.product.id,
                        type: 'access',
                        data
                    }
                    await this.updateProduct(payload)

                    this.clearSupplierCatalogFilterDict('supplierVisibility')

                    this.$notify({
                        title: 'Продукт успешно обновлен',
                        type: 'success'
                    })
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }

                try {
                    await this.getProduct(this.product.id)
                    this.setProductFields()
                } catch (e) {
                    console.log(e)
                }

                this.loading = false
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        }
    }
}
</script>
